export const PRINT_ICON_PATH = require('../../assets/icons/print_1.png');

export const BBPS_LOGO_PATH = require('../../assets/images/BBPSSidebarLogo.png')